import { render, staticRenderFns } from "./silent-renew.vue?vue&type=template&id=8012ffee"
import script from "./silent-renew.vue?vue&type=script&lang=js"
export * from "./silent-renew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports